export default __webpack_public_path__ + "static/media/burger.01017fe1.png";